
import { defineComponent } from "vue";

export default defineComponent({
  name: "widget-14",
  props: {
    widgetClasses: String,
    widgetColor: String,
    title: {
      type: String,
      required: true,
      default: "",
    },
    loading: {
      type: Boolean,
      required: true,
      default: true,
    },
    items: {
      type: null,
      required: true,
      default: [],
    }
  },
});
